// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3eba45c1","453":"258b012d"}[chunkId] + ".chunk.js";
};